import React from 'react';
import { useFormikContext } from 'formik';

import CardDialog from '~/components/CardDialog';
import Button from '~/components/core/Atomic/Buttons/Button';
import ButtonsContainer from '~/components/core/Atomic/Buttons/ButtonsContainer';
import CancelButton from '~/components/core/Buttons/CancelButton';
import SwitchFormik from '~/components/core/Formik/SwitchFormik';
import Text from '~/components/core/TextComponents/Text';
import { TextFieldFormik } from '~/components/TextFieldFormik';

import ReportParameterFields from '../shared/ReportParameterFields';
import ReportTemplateSelect from '../shared/ReportTemplateSelect';
import TargetConfigurationSection from '../shared/TargetConfigurationSection';

import type { FormValues } from './ScheduledReportExportDialog';
import ScheduledReportScheduleSection from './ScheduledReportScheduleSection';
import { SUBSCRIPTION_RULES_TEXTS } from './texts';

interface ScheduledReportExportDialogInnerProps {
  onClose: () => void;
  isEdit: boolean;
}

const ScheduledReportExportDialogInner: React.FC<ScheduledReportExportDialogInnerProps> = ({ onClose, isEdit }) => {
  const { isSubmitting, handleSubmit } = useFormikContext<FormValues>();

  return (
    <CardDialog
      isDialog
      title={isEdit ? SUBSCRIPTION_RULES_TEXTS.EDIT_DIALOG_TITLE : SUBSCRIPTION_RULES_TEXTS.ADD_DIALOG_TITLE}
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      preventClose={isSubmitting}
    >
      <div className="flex flex-col gap-32">
        <div>
          <Text variant={Text.VARIANTS.LG} className="font-bold">
            {SUBSCRIPTION_RULES_TEXTS.SUBSCRIPTION_SETTINGS_TITLE}
          </Text>
        </div>
        <div className="w-1/2">
          <TextFieldFormik
            id="display_name"
            label={SUBSCRIPTION_RULES_TEXTS.SUBSCRIPTION_NAME_LABEL}
            fullWidth
            disabled={isSubmitting}
            className="mb-12"
          />
          <ReportTemplateSelect disabled={isSubmitting} />
        </div>
        <ReportParameterFields disabled={isSubmitting} />
        <div className="-m-12">
          <TargetConfigurationSection />
        </div>
        <div className="-m-12">
          <ScheduledReportScheduleSection />
        </div>
        <div>
          <SwitchFormik
            id="is_active"
            label={SUBSCRIPTION_RULES_TEXTS.ACTIVE_SUBSCRIBE_LABEL}
            disabled={isSubmitting}
          />
        </div>
        <ButtonsContainer className="mt-32">
          <CancelButton disabled={isSubmitting} onClick={onClose} />
          <Button variant="contained" color="primary" disabled={isSubmitting} onClick={() => handleSubmit()}>
            {isEdit ? SUBSCRIPTION_RULES_TEXTS.UPDATE_BUTTON : SUBSCRIPTION_RULES_TEXTS.SAVE_BUTTON}
          </Button>
        </ButtonsContainer>
      </div>
    </CardDialog>
  );
};

export default ScheduledReportExportDialogInner;
